import React from 'react';
const logo = process.env.PUBLIC_URL + '/images/logo.png';

const Footer: React.FC = () => (
  <footer className="fixed bottom-0 left-0 w-full bg-background z-50 border-t border-highlight">
    {/* Mobile Footer - Copyright text centered */}
    <div className="lg:hidden flex justify-center items-center px-6 py-3">
      <div className="text-secondary text-sm">
        &copy; {new Date().getFullYear()} ArtistDesk
      </div>
    </div>

    {/* Desktop Footer - Full content */}
    <div className="hidden lg:flex justify-between items-center px-6 py-3">
      <div className="flex gap-4">
        <a href="/about" className="text-primary font-medium hover:text-highlight transition">About Us</a>
        <a href="/contact" className="text-primary font-medium hover:text-highlight transition">Contact Us</a>
      </div>
      <div className="text-secondary text-sm">
        &copy; {new Date().getFullYear()} ArtistDesk. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
